import { useQuery } from '@tanstack/react-query';

import SearchService, { LuxPlusOffersBySavingsParams } from '~/services/SearchService';

export const luxPlusOffersBySavingsQueryKeys = {
  all: ['lux-plus-offers-by-savings'] as const,
  list: (params: LuxPlusOffersBySavingsParams) => [...luxPlusOffersBySavingsQueryKeys.all, params] as const,
};

interface UseLuxPlusOffersBySavingsParams {
  params: LuxPlusOffersBySavingsParams;
  enabled?: boolean;
}

export function useLuxPlusOffersBySavings({ params, enabled = true }: UseLuxPlusOffersBySavingsParams) {
  return useQuery({
    queryKey: luxPlusOffersBySavingsQueryKeys.list(params),
    queryFn: ({ signal }) => SearchService.getLuxPlusOffersBySavings(params, { signal }),
    enabled,
    staleTime: 30_000,
  });
}
